<template>
  <div class="mt-5">
    <form v-on:submit.prevent="$emit('search', search)">
      <v-layout v-if="!noSearch">
        <v-text-field
          v-model="search"
          solo
          label="Search"
          prepend-inner-icon="mdi-search"
          clearable
        />
        <v-btn
          class="ml-3 mt-1"
          color="primary"
          icon
          large
          @click="$emit('search', search)"
        >
          <v-icon>mdi-find-replace</v-icon>
        </v-btn>
      </v-layout>
    </form>

    <v-data-table
      ref="table"
      :search="searchTable != undefined ? search : ''"
      @click:row="clickTable"
      v-model="select"
      :headers="headers"
      :items="items"
      class="elevation-1"
      hide-default-footer
      :loading="loading"
      :show-select="multiple"
      :single-select="singleSelect"
      :items-per-page="itemsPerPageParam"
      @item-selected="($event) => $emit('item-selected', $event)"
      @input="($event) => $emit('input', $event)"
    >
      <template v-if="createAt" v-slot:item.createAt="{ item }">
        <span>{{ item.createAt | moment }}</span>
      </template>
      <template v-if="!noAction" v-slot:item.action="{ item }">
        <actionsDataTable
          v-model="actions"
          :item="item"
          :loading="loadingAction"
        />
      </template>
    </v-data-table>
    <div v-if="!noPagination && noPageLength == null" class="text-center">
      <v-pagination
        v-model="pagination"
        :length="pageLength"
        @input="inputPage"
      ></v-pagination>
    </div>
    <div
      class="row ma-3 justify-center"
      v-if="!noPagination && noPageLength != null"
    >
      <v-btn
        color="primary"
        :disabled="!page || page <= 1"
        icon
        elevation="1"
        class="mr-3"
        @click="$emit('change-page', !page || page == 1 ? 1 : page - 1)"
      >
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
      <v-btn
        color="primary"
        :disabled="items.length == 0 || items.length < itemsPerPageParam"
        icon
        elevation="1"
        @click="$emit('change-page', !page ? 1 : page + 1)"
      >
        <v-icon>mdi-arrow-right</v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
import actionsDataTable from "./actionsDataTable";
import moment from "moment";

export default {
  props: {
    searchTable: {},
    selectItems: {},
    noSearch: {},
    value: {},
    noPagination: {},
    noPageLength: {},
    createAt: {},
    page: {},
    pageLength: {},
    loadingAction: {},
    actions: {},
    items: {},
    headers: {},
    loading: {},
    noAction: {},
    itemsPerPage: {
       //default: 30
    },
    multiple: {
      default() {
        return false;
      },
    },

    singleSelect: {
      default() {
        return false;
      },
    },
  },
  components: { actionsDataTable },
  computed: {
    itemsPerPageComp() {

      return this.noPagination == true ? this.items.length : this.$rowsLimit;
    },
  },
  data() {
    return {
      search: "",
      select: [],
      pagination: 1,
      paginationLength: 1,
      itemsPerPageParam: this.itemsPerPage
        ? this.itemsPerPage
        : this.$rowsLimit,
    };
  },
  filters: {
    moment: function (date) {
      return moment(date).format("DD/MM/YY H:mm");
    },
  },
  watch: {
    selectItems(value) {
      this.select = value;
    },
    items() {
      this.setItemsPerPage();
    },
    pageLength(value) {
      this.paginationLength = value;
    },
    page(value) {
      this.pagination = value;
    },
    select() {
      this.$emit("select", this.select);
      
    },
  },
  methods: {
    setItemsPerPage() {
      let lengthNoPagination =
        this.noPagination != null ? this.items.length : this.$rowsLimit;

      this.itemsPerPageParam = this.itemsPerPage
        ? this.itemsPerPage
        : lengthNoPagination;
    },
    inputPage() {
      this.$emit("input", this.pagination);
      this.$emit("change-page", this.pagination);
    },
    clickTable(row) {
      this.$emit("click", row);
    },
    selectRow(row) {
      this.$refs.table.select(row);
    },
    selectAllRows() {
      this.$refs.table.toggleSelectAll();
    },
    selectRange(rows) {
      this.clearSelection();
      if (!rows || rows.length == 0) return;
      rows.forEach((row) => {
        this.selectRow(row);
      });
    },
    getSelection() {
      return this.$refs.table.selection;
    },
    clearSelection() {
      return (this.$refs.table.selection = {});
    },
  },

  mounted() {
    this.pagination = this.page;
    this.paginationLength = this.pageLength;
    this.setItemsPerPage();
    if (this.selectItems) this.select = this.selectItems;
  },
};
</script>
